var map = {
	"./coc-logo-fsc.jpeg": "a0b7",
	"./coc-logo-pefc.png": "ccd0",
	"./coc-sign.jpg": "2a38",
	"./firma.jpg": "3971",
	"./logo.jpg": "0f5f",
	"./logo_fsc.jpeg": "7967",
	"./logo_pefc.png": "4fb9",
	"./logoasefor.png": "dadc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3627";